import { render, staticRenderFns } from "./CalendarFlightItem.vue?vue&type=template&id=294247fa&scoped=true&"
import script from "./CalendarFlightItem.vue?vue&type=script&lang=js&"
export * from "./CalendarFlightItem.vue?vue&type=script&lang=js&"
import style0 from "./CalendarFlightItem.vue?vue&type=style&index=0&id=294247fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "294247fa",
  null
  
)

export default component.exports